import React from "react";
import Styles from "./Projects.module.css";
import { Container } from "react-bootstrap";
import Header from "../../general/Header";
import ActionButton from "../../general/ActionButton";
import { useHistory } from "react-router";

const Projects = ({ children, header }) => {
  var history = useHistory();
  return (
    <div className={Styles.ProjectsBox}>
      <Header
        style={{ marginBottom: "26px" }}
        label={header && header.label ? header.label : "Projects"}
        actionButtonText="Contact Me"
        actionButtonIcon="forward"
        actionButtonRoute="/contact-me"
      />
      <Container style={{ height: "100%" }}>{children}</Container>
    </div>
  );
};

export default Projects;
